"use client";

import { GE } from ".constants/gtmEvents";
import { PATH_BLOG } from ".constants/links";
import { PORTALS } from ".constants/portals";
import { Button, usePortalContext } from "@cloai/uikit";
import { useLocale } from "next-intl";
import Image from "next/image";
import { MouseEvent, useCallback } from "react";

import { LanguageCode, useFlag } from "@/components/hooks/useLanguage";
import { usePathname } from "@/i18n";
import { useGTMContext } from "@/providers";

export const HeaderLangButton = () => {
  const { openPortal } = usePortalContext();
  const { sendGTM } = useGTMContext();

  const locale = useLocale();
  const pathname = usePathname();

  const flag = useFlag();

  const isHideLangButton =
    process.env.NEXT_PUBLIC_IS_CN || pathname.includes(PATH_BLOG);

  const openLanguageModal = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      sendGTM({ event: GE.CHOOSE_LANGUAGE_HEADER });
      openPortal(PORTALS.CHANGE_LANG);
    },
    [openPortal, sendGTM],
  );

  if (isHideLangButton) {
    return null;
  }

  return (
    <Button
      startContent={
        <Image
          src={flag(locale as LanguageCode)}
          width={24}
          height={24}
          alt={`${locale} flag`}
          priority
          className="block aspect-square size-6 rounded-md object-cover p-0.5"
        />
      }
      size="sm"
      radius="full"
      onClick={openLanguageModal}
      aria-label="Change Language"
      className="hide pr-2 md:inline-flex"
    >
      {locale.toUpperCase()}
    </Button>
  );
};
